import { FC } from 'react';
import { InfoViewDetailsDataProps } from '../types';
import { InfoViewDetailsContainer, InfoViewDetailsItem } from './InfoViewDetails.styles';
import { CustomTypography } from 'shared/elements/CustomTypography';

type InfoDetailsProps = {
  infoViewDetailsData: InfoViewDetailsDataProps[];
};

const InfoViewDetails: FC<InfoDetailsProps> = ({ infoViewDetailsData }) => {
  return (
    <InfoViewDetailsContainer>
      {infoViewDetailsData?.map((list) => (
        <InfoViewDetailsItem key={list?.name}>
          <CustomTypography fontWeight={600} fontSize={14}>
            {list?.name}
          </CustomTypography>
          <CustomTypography fontSize={14}>{list?.details}</CustomTypography>
        </InfoViewDetailsItem>
      ))}
    </InfoViewDetailsContainer>
  );
};

export default InfoViewDetails;
